import _ from 'lodash'

export default (names) => ({ name }) => _.includes(names, name)
